
export const SPOT_TV_CONNECTION_FAILED = 'SPOT_TV_CONNECTION_FAILED';

export const SPOT_TV_SET_MEETING_SUMMARY = 'SPOT_TV_SET_MEETING_SUMMARY';
